import { ScrollTrigger } from "gsap/ScrollTrigger";

export default class VacancyInShort {
    constructor(elm) {
        this.elm = elm;

        this.init();
    }

    init() {
        ScrollTrigger.create({
            trigger: this.elm,
            start: "top top",
            end: "bottom center",
            onEnter: () => {
                document.body.classList.add('body--inverted');
            },
            onEnterBack: () => {
                document.body.classList.add('body--inverted');
            },
            onLeave: () => {
                document.body.classList.remove('body--inverted');
            },
            onLeaveBack: () => {
                document.body.classList.remove('body--inverted');
            },
        });
    }
}